window.FRONTEND = 'current'
require('./main')
